import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { AuthService } from '@/services/auth.service'
const authService = new AuthService()

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    token: '',
    user: {},
    isLoading: false
  },
  mutations: {
    'SET_TOKEN' (state, token) {
      state.token = token
    },
    'CHANGE_AUTH' (state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
    },
    'SET_USER' (state, userInfo) {
      state.user = userInfo
    },
    'CHANGE_LOADING' (state, isLoading) {
      state.isLoading = isLoading
    }
  },
  actions: {
    async login ({ commit, dispatch }, { email, password }) {
      try {
        const accessToken = await authService.authEmail(email, password)
        const profile = await authService.getProfile(accessToken)
        commit('SET_TOKEN', accessToken)
        commit('SET_USER', profile)
        commit('CHANGE_AUTH', true)
      } catch (e) {
        return e
      }
    },
    logout ({ commit }) {
      commit('CHANGE_AUTH', false)
      commit('SET_TOKEN', '')
      commit('SET_USER', {})
    }
  },
  getters: {
    isLoggedIn (state) {
      return state.isLoggedIn
    },
    user (state) {
      return state.user
    },
    token (state) {
      return state.token
    },
    isLoading (state) {
      return state.isLoading
    }
  },
  modules: {},
  plugins: [createPersistedState()]
})
